import React from "react"
import { PageProps, graphql } from "gatsby"

import { routeParams } from "../../../../../../../routes"
import { Layout } from "../../../../../../../components/Layout"
import { PageMetadata } from "../../../../../../../components/SEO"
import { PaymentSuccessfulScreen } from "../../../../../../../components/checkout/PaymentSuccessfulScreen"
import { PaymentFailedScreen } from "../../../../../../../components/checkout/PaymentFailedScreen"

const PaymentStatusPage = ({ params, location }: PageProps) => {
  const searchParams = new URLSearchParams(location.search)
  const orderId = params[routeParams.orderId]
  const countryCode = params[routeParams.countryCode]
  const slug = params[routeParams.slug]
  const paymentStatus = searchParams.get("status") as "success" | "failed"
  const errorMessage = searchParams.get("errorMessage") as string | undefined

  return (
    <Layout countryCode={countryCode}>
      {paymentStatus === "success" ? (
        <PaymentSuccessfulScreen orderId={orderId} />
      ) : (
        <PaymentFailedScreen
          errorMessage={errorMessage}
          countryCode={countryCode}
          slug={slug}
          orderId={orderId}
        />
      )}
    </Layout>
  )
}

export default PaymentStatusPage

export const Head = () => (
  <PageMetadata
    title={process.env.GATSBY_PARTNER_TITLE || ""}
    description={process.env.GATSBY_PARTNER_DESCRIPTION || ""}
    image={process.env.GATSBY_LOGO || ""}
  />
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
